import { useTranslation } from 'react-i18next';
import { SrpCategoryValue, FilterPill, SrpFilterName } from 'types/srpFilters';
import { srpFilterInitialValues } from 'redux-implementations/srpFilters';
import { stateNames } from 'components/Srp/SearchFilter/CategoryFilter/categoryNames';
import { FilterPillFn } from './useCreateFilterPills';

export const CATEGORY_TRANSLATION_KEYS: Record<string, string> = {
  'Any Category': 'any',
  American: 'american',
  Classic: 'classic',
  Commuter: 'commuter',
  Electric: 'electric',
  Family: 'family',
  'Fuel Efficient': 'fuelEfficient',
  Hybrid: 'hybrid',
  Large: 'large',
  Muscle: 'muscle',
  'Off Road': 'offRoad',
  Small: 'small',
  Sport: 'sport',
  Supercar: 'supercar',
};

export default function useCategoryFilterOptionsPillsCreators(): FilterPillFn {
  const { t } = useTranslation();

  return (filterValue: SrpCategoryValue): FilterPill[] => {
    const uiName = stateNames[filterValue] || filterValue;

    return [
      {
        name: `srp.pills.categories.${CATEGORY_TRANSLATION_KEYS[uiName] || 'any'}`,
        label: t(`srp.pills.categories.${CATEGORY_TRANSLATION_KEYS[uiName] || 'any'}`),
        resetState: { Category: srpFilterInitialValues[SrpFilterName.Category] },
      },
    ];
  };
}
